import React from 'react'
import { parseBool } from 'sidecar-utility-library'
import { toCamelCase } from 'sidecar-utilities'
import toReduxFormField from '../../../enhancers/ToReduxFormField'
import {
  InputButtonGroup,
  StyledButton,
  StyledRadio,
  StyledIcon,
} from './styles'

const Component = ({
  input: { label, value: selectedValue, onChange, onBlur, name, ...restInput },
  meta: { touched, invalid },
  className,
  disabled,
  stack = false,
  ...restProps
}) => {
  return (
    <InputButtonGroup className={className} stack={stack}>
      {restProps.options.map(
        ({ icon, value, label, title = '', disabled: optionDisabled }, idx) => {
          // this is just crazypants, but basically we want to first use any data-testid that
          // we're given (appended with something to tell the diff between each button) and
          // if we have no testId provided, we just create one from the value (if available)
          // falling back to an auto-generated testId using the button label. We cast to string
          // because sometimes the button value is a bool and there is no split() on bools.
          const bestName = value + '' ? value + '' : label
          const passedTestId = restProps['data-testid']
          const testId = passedTestId
            ? `${passedTestId}_${toCamelCase(bestName)}`
            : `input_${toCamelCase(bestName)}-label`
          // an individual option can be disabled without disabling the group
          const isOptionDisabled = Boolean(disabled || optionDisabled)

          return (
            <StyledButton
              key={idx}
              type={icon ? 'icon' : 'text'}
              selected={value === parseBool(selectedValue)}
              invalid={touched && invalid}
              disabled={isOptionDisabled}
              stack={stack}
              data-testid={testId}
              data-heap-redact-text
              title={title}
            >
              <StyledRadio
                type="radio"
                name={name}
                checked={value === parseBool(selectedValue)}
                onChange={onChange}
                value={value}
                onBlur={() => onBlur(selectedValue)}
                data-testid={`input_${toCamelCase(
                  (value ? value : label) + '',
                )}`}
                data-heap-redact-text
                disabled={isOptionDisabled}
              />
              {(icon && <StyledIcon name={icon} />) || label}
            </StyledButton>
          )
        },
      )}
    </InputButtonGroup>
  )
}

Component.displayName = 'InputButtonGroup'

export default toReduxFormField('InputButtonGroup', Component)
